module.exports = __webpack_public_path__ + "assets/images/youmi.727ae30da36d6d06e5d6fe8dadcaef05.png";